import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { NAVIGATION_LABELS } from '../../../helpers/constants'
import NavigationLabel from '../../NavigationLabel/NavigationLabel'

const GroupsLink = ({ withUpsellingRedirect }) => {
  const { t } = useTranslation(['navbar'])

  return (
    <div className="hover-menu-item">
      <NavLink
        className={({ isActive }) =>
          isActive ? 'navmgr-item__link--active' : 'hover-menu-item__link'
        }
        to={
          withUpsellingRedirect
            ? '/dashboard/upselling/groups'
            : '/dashboard/building-dashboard/groups/posts'
        }
      >
        <span>
          {t('navbar:upsellingLinks.communityFeedAndInterestGroups')}
          <NavigationLabel
            type={NAVIGATION_LABELS.HIDDEN}
            locked={Boolean(withUpsellingRedirect)}
          />
        </span>
      </NavLink>
    </div>
  )
}

GroupsLink.propTypes = {
  withUpsellingRedirect: PropTypes.bool,
}

export default GroupsLink
